'use client';

import type { DateOfBirthStep } from '@/modules/authentication/view-model';

import { Form } from '@packages/hook-form-wrapper';

export const DateOfBirth = () => {
	return (
		<Form.DateInput<DateOfBirthStep> label="Date of Birth" name="dateOfBirth" />
	);
};
